import { BusinessServiceType } from "../common/enums/sharedEnums";

const mainGroupName = "Expert";

export enum ServiceOrderType {
  INVENTORY = "inventory",
  DIAGNOSTIC = "diagnostic",
  ERP_EXPRESS = "erpExpress",
  INCOMING_INVENTORY = "incomingInventory",
  OUTGOING_INVENTORY = "outgoingInventory",
  OUTGOING_INCOMING_INVENTORY = "outgoingIncomingInventory",
  OUTGOING_INVENTORY_WITH_COSTING = "outgoingInventoryWithCosting",
  PRE_VISIT_ADVICE = "preVisitAdvice",
  VIRTUAL_VISIT = "virtualVisit",
  RENTAL_VISIT = "rentalVisit",
  COSTING = "costing",
  PPPT = "pppt",
  CONDOMINIUM_VISIT = "condominiumVisit",
  ENERGY_AUDIT = "energyAudit",
  CONDOMINIUM_CREATION = "condominiumCreation",
}

export type DiagnosticsServiceOrderType = Extract<
  ServiceOrderType,
  | ServiceOrderType.DIAGNOSTIC
  | ServiceOrderType.PPPT
  | ServiceOrderType.CONDOMINIUM_VISIT
  | ServiceOrderType.CONDOMINIUM_CREATION
  | ServiceOrderType.ENERGY_AUDIT
>;

export enum ServiceOrderManagedBy {
  AGENCY = "agency",
  MAINGROUP = "mainGroup",
}

interface serviceOrderTypesValues {
  color: string;
  name: ServiceOrderType;
  label: string;
  labelMin: string;
}
interface serviceOrderManagedByValues {
  color: string;
  name: ServiceOrderManagedBy;
  label: string;
  labelMin: string;
}

export interface ServiceOrderTypeOptions {
  label: string;
  value: ServiceOrderType;
}

export const serviceOrderTypeValues: serviceOrderTypesValues[] = [
  {
    color: "#4883F7",
    name: ServiceOrderType.DIAGNOSTIC,
    label: "Diagnostic",
    labelMin: "Diagnostic",
  },
  {
    color: "#000D5B",
    name: ServiceOrderType.ERP_EXPRESS,
    label: "ERP express",
    labelMin: "ERP express",
  },
  {
    color: "#11BFA4",
    name: ServiceOrderType.INCOMING_INVENTORY,
    label: "État des lieux d'entrée",
    labelMin: "EDL Entrée",
  },
  {
    color: "#ECB900",
    name: ServiceOrderType.OUTGOING_INVENTORY,
    label: "État des lieux sortant",
    labelMin: "EDL Sortie",
  },
  {
    color: "#ECB900",
    name: ServiceOrderType.OUTGOING_INVENTORY_WITH_COSTING,
    label: "État des lieux sortant avec chiffrage",
    labelMin: "EDL Sortie/chiffrage",
  },
  {
    color: "#FF0000",
    name: ServiceOrderType.OUTGOING_INCOMING_INVENTORY,
    label: "État des lieux sortant et entrant",
    labelMin: "EDL Sortie/Entrée",
  },
  {
    color: "#11BFA4",
    name: ServiceOrderType.PRE_VISIT_ADVICE,
    label: "Pré-visite conseil",
    labelMin: "Pré-visite conseil",
  },
  {
    color: "#000D5B",
    name: ServiceOrderType.RENTAL_VISIT,
    label: "Visite locative",
    labelMin: "Visite locative",
  },
  {
    color: "#4883F7",
    name: ServiceOrderType.VIRTUAL_VISIT,
    label: "Visite virtuelle",
    labelMin: "Visite virtuelle",
  },
  {
    color: "#000D5B",
    name: ServiceOrderType.COSTING,
    label: "Chiffrage",
    labelMin: "Chiffrage",
  },
  {
    color: "#11BFA4",
    name: ServiceOrderType.PPPT,
    label: "PPPT",
    labelMin: "PPPT",
  },
  {
    color: "#FF0000",
    name: ServiceOrderType.CONDOMINIUM_VISIT,
    label: "Visite  d'immeuble",
    labelMin: "Visite Immeuble",
  },
  {
    color: "#11BFA4",
    name: ServiceOrderType.ENERGY_AUDIT,
    label: "Audit énergétique",
    labelMin: "Audit énergétique",
  },
  {
    color: "#000D5B",
    name: ServiceOrderType.CONDOMINIUM_CREATION,
    label: "Création de copropriété",
    labelMin: "Création copro",
  },
];

export const businessServiceTypeValues = [
  {
    color: "#4883F7",
    name: BusinessServiceType.RENTAL_MANAGEMENT,
    label: "Gestion",
    labelMin: "Gestion",
  },
  {
    color: "#641abf",
    name: BusinessServiceType.CONDOMINIUM_MANAGEMENT,
    label: "Gestion de copropriété",
    labelMin: "Copropriété",
  },
  {
    color: "#11BFA4",
    name: BusinessServiceType.PROPERTY_SALES,
    label: "Transaction immobilière",
    labelMin: "Transaction",
  },
  {
    color: "#FF0000",
    name: BusinessServiceType.RENOVATION_DEVELOPMENT,
    label: "Rénovation et développement",
    labelMin: "Promotion",
  },
  {
    color: "#000D5B",
    name: BusinessServiceType.ERP_EXPRESS,
    label: "ERP Express",
    labelMin: "ERP",
  },
];

export const serviceOrderManagedByValues: serviceOrderManagedByValues[] = [
  {
    color: "#4883F7",
    name: ServiceOrderManagedBy.AGENCY,
    label: "Agence",
    labelMin: "Agence",
  },
  {
    color: "#641abf",
    name: ServiceOrderManagedBy.MAINGROUP,
    label: mainGroupName,
    labelMin: mainGroupName,
  },
];

export const getServiceOrderTypeValuesByType = (type: ServiceOrderType) =>
  serviceOrderTypeValues.find((el) => el.name === type);

export const getServiceOrderTypeValuesByLabel = (label: string) =>
  serviceOrderTypeValues.find((el) => el.label === label);

export const getServiceOrderManagedByValuesByBoolean = (
  isManagedByMainGroup?: boolean
) =>
  serviceOrderManagedByValues.find(
    (el) =>
      el.name ===
      (isManagedByMainGroup
        ? ServiceOrderManagedBy.MAINGROUP
        : ServiceOrderManagedBy.AGENCY)
  );

export const getServiceOrderManagedByValuesByLabel = (label: string) =>
  serviceOrderManagedByValues.find((el) => el.label === label);
